import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { mockUtilizadores } from '../mockPostos';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Input } from '../components/ui/input';
import { Avatar, AvatarFallback, AvatarImage } from '../components/ui/avatar';
import { User, Mail, Search, Briefcase } from 'lucide-react';

const UtilizadoresList = () => {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');

  const filteredUtilizadores = mockUtilizadores.filter(user => {
    const matchSearch = user.nome.toLowerCase().includes(searchTerm.toLowerCase()) || 
                       user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
                       user.cargo.toLowerCase().includes(searchTerm.toLowerCase());
    return matchSearch;
  });

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Utilizadores</h1>
        <p className="text-gray-600 mt-1">Gestão de utilizadores e permissões de carregamento</p>
      </div>

      {/* Pesquisa */}
      <div className="relative max-w-md">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
        <Input
          placeholder="Pesquisar utilizadores..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="pl-10"
        />
      </div>

      {/* Grid de Utilizadores */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {filteredUtilizadores.map(user => (
          <Card 
            key={user.id}
            className="cursor-pointer hover:shadow-lg transition-shadow"
            onClick={() => navigate(`/carregamento/utilizadores/${user.id}`)}
          >
            <CardContent className="pt-6">
              <div className="flex items-start gap-4 mb-4">
                <Avatar className="h-16 w-16">
                  <AvatarImage src={`https://ui-avatars.com/api/?name=${encodeURIComponent(user.nome)}&background=003D7A&color=fff`} />
                  <AvatarFallback className="bg-[#003D7A] text-white">
                    {user.nome.split(' ').map(n => n[0]).join('')}
                  </AvatarFallback>
                </Avatar>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-gray-900">{user.nome}</h3>
                  <p className="text-sm text-gray-600">{user.cargo}</p>
                  <p className="text-xs text-gray-500 mt-1">{user.departamento}</p>
                </div>
                <Badge className={user.ativo ? 'bg-green-100 text-green-800 border-green-200' : 'bg-gray-100 text-gray-800 border-gray-200'}>
                  {user.ativo ? 'Ativo' : 'Inativo'}
                </Badge>
              </div>

              <div className="space-y-2 mb-4">
                <div className="flex items-center gap-2 text-sm text-gray-600">
                  <Mail className="h-4 w-4" />
                  <span className="truncate">{user.email}</span>
                </div>
              </div>

              <div className="grid grid-cols-3 gap-2 pt-4 border-t border-gray-100">
                <div className="text-center">
                  <p className="text-2xl font-bold text-blue-600">{user.totalCarregamentos}</p>
                  <p className="text-xs text-gray-600">Cargas</p>
                </div>
                <div className="text-center">
                  <p className="text-2xl font-bold text-green-600">{user.energiaConsumida}</p>
                  <p className="text-xs text-gray-600">kWh</p>
                </div>
                <div className="text-center">
                  <p className="text-2xl font-bold text-orange-600">{Object.keys(user.permissoes).length}</p>
                  <p className="text-xs text-gray-600">Locais</p>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {filteredUtilizadores.length === 0 && (
        <div className="text-center py-12">
          <User className="h-16 w-16 text-gray-400 mx-auto mb-4" />
          <p className="text-gray-600">Nenhum utilizador encontrado</p>
        </div>
      )}
    </div>
  );
};

export default UtilizadoresList;
